import React from "react";
import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Inbox, ShieldAlert, Home, CreditCard, Activity, LogOut, ShieldCheck, BadgeCheck, Flag, Megaphone, Settings } from "lucide-react";
import { clearAdminToken, getAdminToken } from "@/lib/adminApi";

const nav = [
    { to: "/admin/overview", label: "Overview", icon: LayoutDashboard },
    { to: "/admin/users", label: "Users", icon: Users },
    { to: "/admin/verifications", label: "Verifications", icon: BadgeCheck },
    { to: "/admin/reports", label: "Reports", icon: Flag },
    { to: "/admin/moderation", label: "Moderation", icon: ShieldAlert },
    { to: "/admin/listings", label: "Listings", icon: Home },
    { to: "/admin/broadcast", label: "Broadcast", icon: Megaphone },
    { to: "/admin/leads", label: "Leads", icon: Inbox },
    { to: "/admin/subscriptions", label: "Subscriptions", icon: CreditCard },
    { to: "/admin/settings", label: "Settings", icon: Settings },
    { to: "/admin/activity", label: "Activity", icon: Activity },
];

export default function AdminShell() {
    const navigate = useNavigate();
    if (!getAdminToken()) return <Navigate to="/admin/login" replace />;

    const logout = () => {
        clearAdminToken();
        navigate("/admin/login");
    };

    return (
        <div className="min-h-screen bg-[#0B0B0F] text-white grid grid-cols-[220px,1fr]">
            {/* Sidebar */}
            <aside className="border-r border-white/5 py-6 px-4 flex flex-col">
                <div className="flex items-center gap-2 mb-8 px-2">
                    <div className="h-9 w-9 rounded-xl bg-[#E85D5D] grid place-items-center">
                        <ShieldCheck className="h-5 w-5 text-white" strokeWidth={3} />
                    </div>
                    <div>
                        <div className="font-display font-black leading-none">Flatch</div>
                        <div className="text-[9px] font-black uppercase tracking-widest text-[#E85D5D]">ops</div>
                    </div>
                </div>
                <nav className="space-y-1 flex-1">
                    {nav.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            data-testid={`admin-nav-${n.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-semibold transition ${
                                    isActive
                                        ? "bg-[#E85D5D] text-white"
                                        : "text-white/70 hover:bg-white/5 hover:text-white"
                                }`
                            }
                        >
                            <n.icon className="h-4 w-4" strokeWidth={2.5} />
                            {n.label}
                        </NavLink>
                    ))}
                </nav>
                <button
                    onClick={logout}
                    data-testid="admin-logout-btn"
                    className="mt-4 flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold text-white/70 hover:bg-white/5 hover:text-white"
                >
                    <LogOut className="h-4 w-4" /> Log out
                </button>
            </aside>

            {/* Content */}
            <main className="p-6 min-w-0 overflow-x-hidden">
                <Outlet />
            </main>
        </div>
    );
}
